var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInspireMe = function SvgInspireMe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.4 17.363 1.878-4.085 4.085-1.878-4.085-1.878L11.4 5.437 9.522 9.523 5.437 11.4l4.085 1.878 1.878 4.085Zm0 5.437-3.563-7.838L0 11.4l7.838-3.563L11.4 0l3.563 7.838L22.8 11.4l-7.838 3.563L11.4 22.8ZM24.3 27l-1.762-3.938L18.6 21.3l3.938-1.8 1.762-3.9 1.8 3.9 3.9 1.8-3.9 1.762L24.3 27Z",
    fill: "#767676",
    stroke: "#767676"
  })));
};
export { SvgInspireMe as Component };
export default __webpack_public_path__ + "cee7e27853df06bb8e4aa751441754cd.svg";